import "./Navbar.scss"

import { FC } from "react"

import NavbarItem, { NavbarItemProps } from "./NavbarItem"
import iconMenu from "assets/img/icon-menu.svg"
import NavbarExpand from "./NavbarExpand"
import { useNavbarStore } from "stores/navbar"
import { NavbarState } from "config/constants"
import Routes from "@/routes"
import Avatar from "components/Avatar/Avatar"

type NavbarProps = {
    items: NavbarItemProps[]
    avatarAbbreviation: string,
    avatarLabel: string
}

const Navbar: FC<React.PropsWithChildren<NavbarProps>> = ({
    items,
    avatarAbbreviation,
    avatarLabel
}) => {
    const { navbarState } = useNavbarStore()

    const renderItems = (itemsList?: NavbarItemProps[]) => {
        return itemsList ? itemsList.map((item: NavbarItemProps, index: number) => {
            return <NavbarItem
                {...item}
                isTopLevel={true}
                key={index} />
        }) : null
    }

    return (
        <div className={"navbar " + (navbarState === NavbarState.expanded ? "navbar--is-expanded" : "navbar--is-collapsed")}>
            <nav className="navbar__top">
                {renderItems(items)}
            </nav>
            <div className="navbar__bottom">
                {navbarState === NavbarState.collapsed &&
                    <NavbarExpand
                        iconImg={iconMenu}
                    />
                }
                <NavbarItem
                    label={avatarLabel}
                    route={Routes.userSettings.getPath()}
                    isTopLevel={true}
                    hasNavbarCloseIcon
                    iconView={<Avatar text={avatarAbbreviation} theme="black" />} />
            </div>
        </div>
    )
}

export default Navbar
